import { Pipe, PipeTransform } from '@angular/core';

import { DatasetRow } from '@blaze-shared/schema-domain';

@Pipe({
  name: 'rowIndex',
  standalone: false,
})
export class RowIndexPipe implements PipeTransform {
  transform(
    dataRow: DatasetRow,
    rows: DatasetRow[],
    rowIdColumn: string | undefined,
    idx: number,
  ): number {
    if (!rowIdColumn) {
      return idx;
    }
    const rowId = dataRow[rowIdColumn];
    return rows.findIndex((row) => row[rowIdColumn] === rowId);
  }
}
